import React, { useEffect, useState } from 'react';
import { Button, ToastMessage } from '@cokitchen/cokitchen-components';
import useProductionReportContext from 'contexts/kitchen/production-report.context/context';
import { useNavigate } from 'react-router-dom';
import { MAIN_STORE_ROUTE_KEYS, STORAGE_KEYS } from 'utils/constants';
import EditMealForm from './form';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';

const EditMeal = () => {
  const cokitchenId = localStorage.getItem(STORAGE_KEYS.COKITCHEN);
  const navigate = useNavigate();
  const { setIsBackLink, setBackLinkTitle, selectedMeals } = useProductionReportContext();
  const meals = selectedMeals.map((meal) => ({
    id: meal.id,
    section: { id: meal.section.id, name: meal.section.name },
    category: { id: meal.category.id, name: meal.category.name },
    name: meal.kitchen_item.name,
    qty: meal.minimun_stock_level
  }));
  const [formData, setFormData] = useState(meals);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setIsBackLink(true);
    setBackLinkTitle('Return to previous');
    return () => {
      setIsBackLink(false);
      setBackLinkTitle('');
    };
  }, []);

  useEffect(() => {
    if (selectedMeals.length === 0) navigate(MAIN_STORE_ROUTE_KEYS.KITCHEN_PRODUCTION_REPORT);
  }, []);

  const hasEmptyField = formData.some((meal) => {
    return meal.section.name === '' || meal.category.name === '' || meal.name === '' || !meal.qty;
  });

  const handleUpdate = async () => {
    const data = {
      data: formData.map((meal) => ({
        id: meal.id,
        minimun_stock_level: meal.qty,
        category: meal.category.name,
        section: meal.section.name
      }))
    };
    try {
      setLoading(true);
      const res = await apiService.post(`cokitchen-item/${cokitchenId}/bulk-update`, {
        data
      });
      if (res) {
        toast(<ToastMessage type='success' message='Meals updated successfully' />);
        navigate(MAIN_STORE_ROUTE_KEYS.KITCHEN_PRODUCTION_REPORT);
      }
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className='mx-auto max-w-md mt-[26px]'>
      {formData.map((meal, i) => (
        <EditMealForm key={i} meal={meal} i={i} setFormData={setFormData} formData={formData} />
      ))}

      <Button
        variant='block'
        color='primary'
        small
        className='text-sm mb-10'
        disabled={hasEmptyField}
        onClick={handleUpdate}
        loading={loading}>
        Confirm
      </Button>
    </div>
  );
};

export default EditMeal;
